import React, {
  JSX,
  PropsWithChildren,
  ReactNode,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useFormContext } from 'react-hook-form';
import { JsxElement } from 'typescript';

import styles from './StepperV2.module.scss';
import { CLASSES } from '../../helper/functions';
import useQuestionStore, { Form } from '../../store/QuestionStore';
import Icon from '../icon/Icon';
import Portal from '../portal/Portal';

interface StepperV2Props extends PropsWithChildren {
  items?: StepperV2Items[];
  currentStepIndex: number;
}

export interface StepperV2Items {
  number: number;
  order: number;
  label: string;
  completed: boolean;
  src: string;
  element?: ReactNode;
}

export const DEFAULT_FORM: StepperV2Items[] = [
  {
    number: 1,
    order: 0,
    label: 'Liquidation Risk',
    completed: false,
    src: '/icons/calculator.svg',
  },
  {
    number: 2,
    order: 1,
    label: 'Funding Risk',
    completed: false,
    src: '/icons/calculator.svg',
  },
  {
    number: 3,
    order: 2,
    label: 'Credit Risk',
    completed: false,
    src: '/icons/calculator.svg',
  },
  {
    number: 4,
    order: 3,
    label: 'Comodity Risk',
    completed: false,
    src: '/icons/form.svg',
  },
  {
    number: 5,
    order: 4,
    label: 'Currency Risk',
    completed: false,
    src: '/icons/form.svg',
  },
  {
    number: 6,
    order: 5,
    label: 'Interest Risk',
    completed: false,
    src: '/icons/form.svg',
  },
  {
    number: 7,
    order: 6,
    label: 'Operation Risk',
    completed: false,
    src: '/icons/form.svg',
  },
  {
    number: 8,
    order: 7,
    label: 'Disaster Risk',
    completed: false,
    src: '/icons/form.svg',
  },
  {
    number: 9,
    order: 8,
    label: 'Compliance Risk',
    completed: false,
    src: '/icons/form.svg',
  },
  {
    number: 10,
    order: 9,
    label: 'Legal Risk',
    completed: false,
    src: '/icons/form.svg',
  },
];

const Stepper: React.FC<StepperV2Props> = ({
  items = DEFAULT_FORM,
  currentStepIndex,
  children,
}) => {
  //#region Variable / useMemo / State
  const [stepperItem, setStepperItem] = useState<StepperV2Items[]>(
    items || DEFAULT_FORM
  );

  const selectedForm = useMemo(() => {
    return stepperItem[currentStepIndex];
  }, [currentStepIndex]);
  //#endregion

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <div className={styles.stepperContainer}>
          <div className={styles.mainLogoContainer}>
            <Icon className={styles.mainLogo} src="/images/MainLogo.png" flat />
          </div>

          {stepperItem.map((form) => (
            <div key={form.order} className={styles.stepperContainerItem}>
              <div
                className={CLASSES(
                  styles.selectedForm,
                  (form.order == currentStepIndex || form.completed) &&
                    styles.selected__
                )}
              >
                {form.completed ? <Icon src="/icons/tick.svg" /> : form.number}
              </div>

              <div className={styles.stepperContainerItemLabel}>
                {form.label}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.formContainer}>
          <div className={styles.formLabel}>{selectedForm?.label}</div>
          <div className={styles.formContentContainer}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Stepper;
